module.exports = __webpack_public_path__ + "img/startup.ff9b786.svg";